<template>


    <div class="flex-wrap w-100 model-grid ms-auto me-auto"
    :class="{'d-flex' : place !== 'home'}">
        <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>
        <modal :show-modal="showModal" :image-src="modalImage" @close="closeModal"></modal>

<!--        <VueSlickCarousel v-if="place === 'home'"  :slides-to-show="slidesToShow"-->
<!--                          :infinite="true" :autoplay="false"-->
<!--                          :edgeFriction="1" :dotsClass="'slick-dots custom-dot-class'"-->
<!--                          :dots="true">-->
      <Swiper
          v-if="place === 'home'"
          :loop="true"
          :pagination="{ clickable: true }"
          slides-per-view="1"
          :space-between="20"
          class="swiper-model-cards"
      >
        <SwiperSlide
            v-for="(product, index) in products"
            :key="`model-${product.id}`"
        >
            <div class="model-card-block justify-content-center justify-content-lg-end" :key="`model-${product.id}`"
                 :id="`model-${product.id}`"
                 style="height: 500px;"
                 :class="{'col-lg-4 col-md-6': size === 'small' || orderStatus === 'Delivered', 'col-md-6 col-lg-3 ': size !== 'small', 'model-card-block--catalog': place==='gallery'}"
                 v-for="(product, index) in products" v-if="products.length > 0">
                <a class="w-100"
                   :href="'/gallery/' + product.slug">

                    <div class="card-model d-flex flex-column justify-content-between" :data-id="product.id"
                         :data-price="product.price">
                        <div class="position-relative">

                            <input type="hidden" :value="product.type" name="type">
                            <input type="hidden" v-if="order === 'order'" class="model-id" :value="product.model.id"
                                   name="model.id">
                            <i class="fa-solid fa-xmark icon-cross-absolute" v-if="orderStatus === 'Declined'"
                               @click="deleteModel($event,index)"></i>

                            <i class="fa-solid fa-xmark icon-cross-absolute" v-if="size === 'smaller'"
                               @click="deleteItem($event,product)"></i>

                            <video
                                v-if="product.dynamic_img !== undefined"
                                :src="product.dynamic_img"
                                class="product-image box-shadow-1"
                                @mouseleave="showOnHoverOut(product)"
                                @click="show3dNewTab(product)"
                                autoplay
                                type="video/mp4"
                                loop
                                :class="{'d-none': product.mouseover === false}"
                            ></video>
                            <img
                                v-if="product.img && (order !== 'order' && product.model === undefined  ) "
                                :src="product.img"
                                @mouseover="showOnHoverBaseModel(product)"
                                :alt="product.model.title"
                                :class="{'d-none': product.mouseover === true}"
                            >
                            <div v-if="order === 'order'">
                                <img v-if="product.model.path === undefined" :src="'/' + product.model.img" :alt="product.model.title">
                                <img v-if="product.model.path !== undefined" :src="product.img" :alt="product.model.title">
                            </div>

                            <div class="tags-block d-flex flex-wrap mx-4" v-if="order !== 'order' && size !== 'smaller' && place !== 'home'">
                                <div v-for="tag in product.tags" class="background-hover-tag mb-3 me-1 ">
                                    <a class="text-decoration-none js-tags ">
                                        <p :data-slug="tag.slug">{{ lang === 'ar-sa' ? tag.title['ar-sa'] : tag.title['en'] }}</p>
                                    </a>
                                </div>
                            </div>

                            <h3 class="title-model mx-4" v-model="descriptionModel = product.model.title"
                                v-if="order === 'order'" :data-description="product.description">
                                <!--                                                {{-->
                                <!--                                                    lang === 'ar-sa' ? product.model.title && product.model.title['ar-sa'] : product.model.title && product.model.title['en']-->
                                <!--                                                }}-->
                            </h3>
                            <h3 class="title-model mx-4" v-model="descriptionModel = product.description" v-else
                                :data-description="product.description">
                                {{ lang === 'ar-sa' ? product.title['ar-sa'] : product.title['en'] }}</h3>

                            <p class="description-model mx-4"
                               v-html="">
                                {{ lang === 'ar-sa' ? getShortDescription(product.description['ar-sa']) : getShortDescription(product.description['en']) }}
                            </p>
                            <div v-if="order === 'order'" class="d-flex  flex-wrap justify-content-between mt-auto">
                                <div class="col-12 mb-md-5">
                                    <div v-if="product.model.type === 'App\\Models\\Model\\ClientModel'"
                                         class="d-flex flex-column">
                                        <p>{{ titles.material }}: {{ product.model.material.name }}</p>
                                        <p>{{ titles.infillPercentage }}: {{ product.model.infill_percentage * 20 }} %</p>
                                        <p>{{ titles.layerHeight }}: {{ product.model.layer_height / 10 }} mm</p>
                                        <div class="color d-flex mt-3">
                                            <p>{{ titles.color }}:</p>
                                            <div class="show-color" :style="{'background-color':  product.model.color }"></div>
                                        </div>
                                    </div>
                                    <h4 v-else>
                                        <div class="color d-flex mt-3">
                                            <p>{{ titles.color }}:</p>
                                            <div class="show-color" :style="{'background-color':  product.color }"></div>
                                        </div>
                                        <strong>{{ lang === 'ar-sa' ? product.model.title['ar-sa'] : product.model.title['en'] }}</strong>
                                    </h4>
                                </div>
                                <div
                                    class="d-flex flex-column flex-xxl-row price__block align-items-xxl-center justify-content-xxl-between w-100">
                                    <div class="count-in-order pt-3">
                                        <div class="quantity pt-0 m-0" v-if="orderStatus === 'Declined'">
                                            <button class="js-plus-btn plus-btn" @click="calculatePrice($event,'plus')"
                                                    type="button"
                                                    name="button">
                                                <i class="fa-solid fa-plus"></i>
                                            </button>
                                            <input type="text" name="name" class="order-model-count"
                                                   :data-price="product.model.price "
                                                   :value="product.count">
                                            <input type="hidden" name="type" :data-type="product.model.type"
                                                   :value="product.model.type">
                                            <button class="js-minus-btn minus-btn" :disabled="disabledMinus"
                                                    @click="calculatePrice($event,'minus')" type="button"
                                                    name="button">
                                                <i class="fa-solid fa-minus"></i>
                                            </button>
                                        </div>
                                        <h4 v-else>{{ titles.count }} : <strong>{{ product.count }}</strong></h4>
                                    </div>

                                    <div class="pt-3">
                                        <h4>{{ titles.price }} : <strong class="calculate-price">{{
                                                product.model.price
                                            }}</strong></h4>
                                    </div>
                                </div>
                                <div class="">
                                    <h4>{{ titles.priceTotalWithDiscount }} : <strong class="calculate-price">{{
                                            product.sum
                                        }}</strong></h4>
                                </div>
                            </div>

                        </div>


                        <div class="card-model__block-info">
                            <div class="d-flex size-block my-3">
                                <p class="model-info-title">{{ lang === 'ar-sa' ? 'مقاس' : 'Size' }}</p>
                                <p class="me-3 model-info-subtitle">{{ product.size }}</p>
                            </div>
                            <!--                    <div  class="" v-if="order !== 'order' && place !== 'home'">-->
                            <!--                        <div class="dropdown my-4 w-auto mx-0 js-dropdown-colors dropdown-colors">-->
                            <!--                            <p class="w-auto model-info-title">{{ chooseColor }}</p>-->
                            <!--                            <a class="dropdown-toggle px-0 text-decoration-none   js-dropdown navigation-footer"-->
                            <!--                               href="#" role="button"-->
                            <!--                               data-bs-toggle="dropdown"-->
                            <!--                               aria-expanded="false">-->
                            <!--                            </a>-->
                            <!--                            <ul class="dropdown-menu dropdown-menu-colors">-->
                            <!--                                <li class="js-show-color  h-100 show-color" v-model="defaultColor"-->
                            <!--                                    @click="addColor($event,color,product)"-->
                            <!--                                    v-for="color in (product.material.colors)"-->
                            <!--                                    :style="{backgroundColor: color}">-->
                            <!--                                </li>-->
                            <!--                            </ul>-->
                            <!--                        </div>-->
                            <!--                    </div>-->
                            <div class="mb-3">
                                <p class="price">{{ product.price }}{{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }}</p>
                            </div>

                            <div class="mt-auto d-flex align-items-center justify-content-between" v-if="order !== 'order'">
                                <a class="btn-purple px-0 btn col-5 ms-0 me-4"
                                   :href="'/gallery/' + product.slug"
                                >{{ showMore }}</a>
                                <div class="d-flex justify-content-between align-items-center"
                                     @click.prevent>
                                    <div class="wishlist__icon-block  ms-0 me-1" @click="createWishlist($event, product)">
                                        <img
                                            :src="product.added_in_wishlist ? '/images/icons/icon-lable-full.svg' : '/images/icons/icon-lable.svg'"
                                            class="add-cart-icon"
                                            alt="cart">
                                        <!--                            <i class="fa-regular fa-bookmark wishlist__icon " @click="createWishlist(product)"></i>-->
                                    </div>
                                    <div class="like__block d-flex justify-content-center align-items-center"
                                         :class="{'d-none': showLike}"
                                         v-if=" order !== 'order'  "

                                         @click="changeLikesStatus($event,product)">
                                        <img
                                            :src=" product.liked ?  '/images/icons/icon-like-full.svg' : '/images/icons/icon-like.svg'"
                                            class="add-cart-icon"
                                            v-bind:class="{ 'fa-solid' : product.liked}"
                                            alt="like">
                                    </div>

                                    <!--                            <img src="../../../../public/images/icons/icon-cart.svg"-->
                                    <!--                                 class="add-cart-icon ms-1 me-0 js-add-to-cart"-->
                                    <!--                                 @click="addToCart($event,product)" alt="cart">-->
                                </div>
                            </div>
                        </div>

                    </div>
                </a>
            </div>
        </SwiperSlide>
      </Swiper>
<!--        </VueSlickCarousel>-->

        <div class="model-card-block justify-content-center justify-content-lg-end" :key="`model-${product.id}`"
             :id="`model-${product.id}`"
             :class="{'col-lg-4 col-md-6': size === 'small' || orderStatus === 'Delivered', 'col-md-6 col-lg-3 ': size !== 'small', 'model-card-block--catalog': place==='gallery'}"
             v-for="(product, index) in products" v-if="products.length > 0 && place !== 'home'">

            <a class="w-100"
               :href="'/gallery/' + product.slug">

            <div class="card-model d-flex flex-column justify-content-between" :data-id="product.id"
                 :data-price="product.price">
                <div class="position-relative">

                    <input type="hidden" :value="product.type" name="type">
                    <input type="hidden" v-if="order === 'order'" class="model-id" :value="product.model.id"
                           name="model.id">
                    <i class="fa-solid fa-xmark icon-cross-absolute" v-if="orderStatus === 'Declined'"
                       @click="deleteModel($event,index)"></i>

                    <i class="fa-solid fa-xmark icon-cross-absolute" v-if="size === 'smaller'"
                       @click="deleteItem($event,product)"></i>

                    <video
                        v-if="product.dynamic_img !== undefined"
                        :src="product.dynamic_img"
                        class="product-image box-shadow-1"
                        @mouseleave="showOnHoverOut(product)"
                        @click="show3dNewTab(product)"
                        autoplay
                        type="video/mp4"
                        loop
                        :class="{'d-none': product.mouseover === false}"
                    ></video>
                    <img
                        v-if="product.img && (order !== 'order' && product.model === undefined  ) "
                        :src="product.img"
                        @mouseover="showOnHoverBaseModel(product)"
                        alt="model-img"
                        :class="{'d-none': product.mouseover === true}"
                    >
                    <div v-if="order === 'order'">
                        <img v-if="product.model.path === undefined" :src="'/' + product.model.img" alt="model-img">
                        <img v-if="product.model.path !== undefined" :src="product.img" alt="model-imgc">
                    </div>

                    <div class="tags-block d-flex flex-wrap mx-4" v-if="order !== 'order' && size !== 'smaller' && place !== 'home'">
                        <div v-for="tag in product.tags" class="background-hover-tag mb-3 me-1 ">
                            <a class="text-decoration-none js-tags ">
                                <p :data-slug="tag.slug">{{ lang === 'ar-sa' ? tag.title['ar-sa'] : tag.title['en'] }}</p>
                            </a>
                        </div>
                    </div>

                    <h3 class="title-model mx-4" v-model="descriptionModel = product.model.title"
                        v-if="order === 'order'" :data-description="product.description">
<!--                                                {{-->
<!--                                                    lang === 'ar-sa' ? product.model.title && product.model.title['ar-sa'] : product.model.title && product.model.title['en']-->
<!--                                                }}-->
                    </h3>
                    <h3 class="title-model mx-4" v-model="descriptionModel = product.description" v-else
                        :data-description="product.description">
                        {{ lang === 'ar-sa' ? product.title['ar-sa'] : product.title['en'] }}</h3>

                    <p class="description-model mx-4"
                    v-html="">
                       {{ lang === 'ar-sa' ? getShortDescription(product.description['ar-sa']) : getShortDescription(product.description['en']) }}
                    </p>
                    <div v-if="order === 'order'" class="d-flex  flex-wrap justify-content-between mt-auto">
                        <div class="col-12 mb-md-5">
                            <div v-if="product.model.type === 'App\\Models\\Model\\ClientModel'"
                                 class="d-flex flex-column">
                                <p>{{ titles.material }}: {{ product.model.material.name }}</p>
                                <p>{{ titles.infillPercentage }}: {{ product.model.infill_percentage * 20 }} %</p>
                                <p>{{ titles.layerHeight }}: {{ product.model.layer_height / 10 }} mm</p>
                                <div class="color d-flex mt-3">
                                    <p>{{ titles.color }}:</p>
                                    <div class="show-color" :style="{'background-color':  product.model.color }"></div>
                                </div>
                            </div>
                            <h4 v-else>
                                <div class="color d-flex mt-3">
                                    <p>{{ titles.color }}:</p>
                                    <div class="show-color" :style="{'background-color':  product.color }"></div>
                                </div>
                                <strong>{{ lang === 'ar-sa' ? product.model.title['ar-sa'] : product.model.title['en'] }}</strong>
                            </h4>
                        </div>
                        <div
                            class="d-flex flex-column flex-xxl-row price__block align-items-xxl-center justify-content-xxl-between w-100">
                            <div class="count-in-order pt-3">
                                <div class="quantity pt-0 m-0" v-if="orderStatus === 'Declined'">
                                    <button class="js-plus-btn plus-btn" @click="calculatePrice($event,'plus')"
                                            type="button"
                                            name="button">
                                        <i class="fa-solid fa-plus"></i>
                                    </button>
                                    <input type="text" name="name" class="order-model-count"
                                           :data-price="product.model.price "
                                           :value="product.count">
                                    <input type="hidden" name="type" :data-type="product.model.type"
                                           :value="product.model.type">
                                    <button class="js-minus-btn minus-btn" :disabled="disabledMinus"
                                            @click="calculatePrice($event,'minus')" type="button"
                                            name="button">
                                        <i class="fa-solid fa-minus"></i>
                                    </button>
                                </div>
                                <h4 v-else>{{ titles.count }} : <strong>{{ product.count }}</strong></h4>
                            </div>

                            <div class="pt-3">
                                <h4>{{ titles.price }} : <strong class="calculate-price">{{
                                        product.model.price
                                    }}</strong></h4>
                            </div>
                        </div>
                        <div class="">
                            <h4>{{ titles.priceTotalWithDiscount }} : <strong class="calculate-price">{{
                                    product.sum
                                }}</strong></h4>
                        </div>
                    </div>

                </div>


                <div class="card-model__block-info">
                    <div class="d-flex size-block my-3">
                        <p class="model-info-title">{{ lang === 'ar-sa' ? 'مقاس' : 'Size' }}</p>
                        <p class="me-3 model-info-subtitle">{{ product.size }} {{ window.getTranslationText("inches") }}</p>
                    </div>
<!--                    <div  class="" v-if="order !== 'order' && place !== 'home'">-->
<!--                        <div class="dropdown my-4 w-auto mx-0 js-dropdown-colors dropdown-colors">-->
<!--                            <p class="w-auto model-info-title">{{ chooseColor }}</p>-->
<!--                            <a class="dropdown-toggle px-0 text-decoration-none   js-dropdown navigation-footer"-->
<!--                               href="#" role="button"-->
<!--                               data-bs-toggle="dropdown"-->
<!--                               aria-expanded="false">-->
<!--                            </a>-->
<!--                            <ul class="dropdown-menu dropdown-menu-colors">-->
<!--                                <li class="js-show-color  h-100 show-color" v-model="defaultColor"-->
<!--                                    @click="addColor($event,color,product)"-->
<!--                                    v-for="color in (product.material.colors)"-->
<!--                                    :style="{backgroundColor: color}">-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="mb-3">
                        <p class="price">{{ product.price }}{{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }}</p>
                    </div>

                    <div class="mt-auto d-flex align-items-center justify-content-between" v-if="order !== 'order'">
                        <a class="btn-purple px-0 btn col-5 ms-0 me-4"
                           :href="'/gallery/' + product.slug"
                        >{{ showMore }}</a>
                        <div class="d-flex justify-content-between align-items-center"
                             @click.prevent>
                            <div class="wishlist__icon-block  ms-0 me-1" @click="createWishlist($event, product)">
                                <img
                                    :src="product.added_in_wishlist ? '/images/icons/icon-lable-full.svg' : '/images/icons/icon-lable.svg'"
                                    class="add-cart-icon"
                                    alt="cart">
                                <!--                            <i class="fa-regular fa-bookmark wishlist__icon " @click="createWishlist(product)"></i>-->
                            </div>
                            <div class="like__block d-flex justify-content-center align-items-center"
                                 :class="{'d-none': showLike}"
                                 v-if=" order !== 'order'  "

                                 @click="changeLikesStatus($event,product)">
                                <img
                                    :src=" product.liked ?  '/images/icons/icon-like-full.svg' : '/images/icons/icon-like.svg'"
                                    class="add-cart-icon"
                                    v-bind:class="{ 'fa-solid' : product.liked}"
                                    alt="like">
                            </div>

<!--                            <img src="../../../../public/images/icons/icon-cart.svg"-->
<!--                                 class="add-cart-icon ms-1 me-0 js-add-to-cart"-->
<!--                                 @click="addToCart($event,product)" alt="cart">-->
                        </div>
                    </div>
                </div>

            </div>
           </a>
        </div>

    </div>

</template>

<script type="application/javascript">
import TheLoaderComponent from "./TheLoaderComponent";
import Modal from "./Modal.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
// import VueSlickCarousel from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'swiper/css';
export default {
    components: {Modal, TheLoaderComponent,
      // VueSlickCarousel
      Swiper,
      SwiperSlide
    },
    name: "CardModelConfiguration",
    props: ['products', 'size', 'order', 'orderStatus', 'place', 'lang'],

    data() {
        return {
            showModal: false,
            modalImage: '',
            descriptionModel: '',
            showLoader: false,
            slidesToShow: 1,
            arrSlugs: [],
            arrayObjModelToCart: [],
            itemsFromStorage: userId && JSON.parse(localStorage.getItem(`cart-basic-${userId}`)),
            likeStatus: false,
            showLike: autorizetion && autorizetion !== 0,
            disabledMinus: false,
            linkOrderModel: null,
            showMore: 'Show more',
            chooseColor: "Choose color",
            defaultColor: '#ff0000',
            lang: window.currentLang,

            titles: {
                description: '',
                material: '',
                color: '',
                layerHeight: '',
                infillPercentage: '',
                count: '',
                price: '',
            },
            countWishList: [],
        }
    },
    computed() {
        this.changeContent()
    },
    created() {
        this.changeContent()
    },
    updated() {
        autorizetion && autorizetion == 0
        this.itemsFromStorage && this.itemsFromStorage.forEach(item => {
            this.arrayObjModelToCart.push(item)
        })

        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
    },

    mounted() {
        this.updateSlidesToShow();
        let jsCreateOrderBtn = document.querySelector('html .js-create-order')
        jsCreateOrderBtn && jsCreateOrderBtn.addEventListener('click', this.createOrderClient)
        addEventListener("resize", (event) => {
           this.updateSlidesToShow();
        });
        this.changeContent()

    },

    methods: {

        updateSlidesToShow() {
            if (window.innerWidth < 768) {
                this.slidesToShow = 1;
            } else if (window.innerWidth < 1024) {
                this.slidesToShow = 2;
            } else if (window.innerWidth < 1400) {
                this.slidesToShow = 3;
            } else {
                this.slidesToShow = 4;
            }
        },
        getShortDescription(description) {
            let plainText = description.replace(/<[^>]*>/g, '');

            let truncatedText = plainText.substring(0, 75);
            let lastSpaceIndex = truncatedText.lastIndexOf(' ');
            let firstSentence = truncatedText.substring(0, lastSpaceIndex).trim();

            return firstSentence;
        },
        showImgModel(product) {
            return product.img;
        },
        showOnHoverBaseModel(product) {
            if (product.file_hash !== null) {
                product.mouseover = true;
            }
        },
        showOnHoverOut(product) {
            if (product.file_hash !== null) {
                product.mouseover = false;
            }
        },

        show3dNewTab(product) {
            event.preventDefault();
            var params = {
                modelIdentificator: product.file_hash + '_' + product.file_size + '_' + product.color.replace('#', ''),
            };
            var queryString = Object.keys(params).map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            }).join('&');
            var url = window.location.protocol
                + '//' + window.location.host
                + '/' + 'gallery/3d-preview/'
                + queryString;
            window.open(url, '_blank');
        },


        closeModal(event) {
            this.showModal = false;
            this.modalImage = '';
        },


        changeContent() {
            if (window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'
                this.showMore = 'أظهر المزيد'
                this.titles.description = 'وصف'
                this.titles.color = 'اللون'
                this.titles.material = 'المواد '
                this.titles.layerHeight = 'دقة الطباعة'
                this.titles.infillPercentage = 'كثافة الحشوة'
                this.titles.count = 'الكمية'
                this.titles.price = 'السعر'


            } else {
                this.lang = 'en'
                this.titles.count = 'Count'
                this.titles.price = 'Price'
                this.titles.priceTotalWithDiscount = 'Price total with discount'
                this.titles.description = 'Description'
                this.titles.color = 'Color'
                this.titles.material = 'Material '
                this.titles.layerHeight = 'Layer height'
                this.titles.infillPercentage = 'Infill percentage'


                this.showMore = 'Show more'
            }
        },
        // !!!!!!!!!!!!!!!
        addColor(event, color, product) {


            if (product.dynamic_img !== undefined) {
                let oldColor = product.color;
                product.img = product.img.replace(oldColor.replace('#', ''), color.replace('#', ''));
                product.dynamic_img = product.dynamic_img.replace(oldColor.replace('#', ''), color.replace('#', ''));
            }

            let listColors = document.querySelectorAll('.js-show-color')
            let selectMenues = document.querySelectorAll('.dropdown-menu-colors')
            selectMenues.forEach(menu => {
                menu.classList.remove('active')
            });
            product.color = color

            //color choose
            let parent = event.target.closest('.js-dropdown-colors')
            let showColor = parent.querySelector('.js-dropdown ')
            showColor.style.background = color

            listColors.forEach(list => {
                list.classList.remove('border-danger', 'border')
            })
            event.target.classList.add('border-danger', 'border')
            this.colorModel = color
        },

        // !!!!!!!!!!!!!!!
        showDetailsModelFromOrder(event, id) {
            // event.preventDefault()
            // event.currentTarget.getAttribute('data-type') !== 'App\\Models\\Model\\ClientModel' && (location.href = `/gallery/${id}`)
        },

        calculatePrice(event, action) {
            let vm = this
            let parent = event.target.closest('.price__block')
            let count = parent.querySelector('.order-model-count').value
            let price = parent.querySelector('.order-model-count').getAttribute('data-price')
            let showPrice = parent.querySelector('.calculate-price')
            action === 'plus' && ++count
            action === 'minus' && --count

            showPrice.textContent = price * count

            + count <= 0 ? showPrice.textContent = '0' : showPrice.textContent = price * count

        },

        deleteModel(event) {
            event.target.closest('.item').remove()
        },
        addToCart(event, product) {
            let parent = event.currentTarget.closest('.model-card-block')
            let id = +parent.querySelector('.card-model').getAttribute('data-id')
            let cartIcon = document.querySelectorAll('.fa-cart-shopping')
            let price = parent.querySelector('.card-model').getAttribute('data-price')
            let img = parent.querySelector('img').getAttribute('src')
            let type = parent.querySelector('.card-model input').getAttribute('value')
            let count = 1
            let vm = this
            let colorsSelcted = new Object();
            let selectedColor = product.color
            if (selectedColor === undefined) {
                selectedColor = product.material.colors[0]
            }
            colorsSelcted[selectedColor] = count
            let objModelInfo = {
                id,
                name: product.title,
                img,
                description: product.description,
                price: +price,
                priceCalculate: +price,
                count,
                type,
                material: product.material.name,
                category: product.categories,
                colors: product.material.colors,
                //arr of prod selected colors
                colorsSelected: colorsSelcted,
                color: selectedColor,
                countColor: count,
                newCount: [count],
                oldCountColor: 0,
                arrColors: [],
                countDrop: count,
                newCountColor: [],
                clickLi: [false],
            }
            if (product.file_hash !== undefined) {
                objModelInfo.file_size = product.file_size;
                objModelInfo.file_hash = product.file_hash;
                objModelInfo.dynamic_img = '/storage/models_dynamic_mp4/' + product.file_hash + '_' + product.file_size + '_' + product.color.replace('#', '') + '.mp4';
                objModelInfo.mouseover = false;
            }
            vm.arrayObjModelToCart = []
            JSON.parse(localStorage.getItem(`cart-basic-${userId}`)) && JSON.parse(localStorage.getItem(`cart-basic-${userId}`)).forEach(item => {
                vm.arrayObjModelToCart.push(item)
            })

            let flagInCartSelectedColor = false
            vm.arrayObjModelToCart.forEach((productInCart) => {
                if (productInCart.id === objModelInfo.id && productInCart.color === objModelInfo.color) {
                    productInCart.count += count;
                    productInCart.priceCalculate = productInCart.price * productInCart.count;
                    flagInCartSelectedColor = true;
                }
            });
            if (!flagInCartSelectedColor) {
                vm.arrayObjModelToCart.push(objModelInfo)
            }
            localStorage.setItem(`cart-basic-${userId}`, JSON.stringify(vm.arrayObjModelToCart));
            if (localStorage.getItem('lang') === 'ar-sa') {
                window.notify('تمت الإضافة إلى السلة', 'success')

            } else {
                window.notify('Added to cart', 'success')
            }
            cartIcon.forEach(item => {
                vm.arrayObjModelToCart.length !== 0 && item.classList.remove('d-none')
            })
        },

        changeLikesStatus(event, product) {
            let vm = this
            let parentId = event.target.closest('.card-model').getAttribute('data-id')
            let url = !event.target.classList.contains('fa-solid') ? `/${parentId}/like` : `/${parentId}/unlike`
            event.target.classList.toggle('fa-solid')
            if (event.target.classList.contains('fa-solid')) {
                event.target.src = '/images/icons/icon-like-full.svg';
            } else {
                event.target.src = '/images/icons/icon-like.svg';
            }
            axios.post(url,).then(function (response) {
            })
        },

        deleteItem(e, product) {
            let vm = this
            let iconCounts = document.querySelectorAll('.js-count-items')

            vm.products = vm.products.filter(item => item.id !== product.id)

            axios.delete(`/wishlist/delete/${product.id}`).then(function (response) {
                localStorage.setItem('itemCount', vm.products.length)
                iconCounts.forEach(count => {
                    count.textContent = vm.products.length
                })

                if (localStorage.getItem('lang') === 'ar-sa') {
                    window.notify('تم حذف عنصر قائمة الرغبات', 'success')
                } else {
                    window.notify('Wishlist item deleted', 'success')
                }
            })
        },

        createWishlist(e, product) {
            if (autorizetion) {

                window.location.href = '/login';
                return;
            }
            let vm = this
            let iconCounts = document.querySelectorAll('.js-count-items')
            let countWishInLocal = parseInt(iconCounts[0].textContent);
            //if no have wished products in local
            if (countWishInLocal !== vm.countWishList.length) {
                axios.get(`/wishlist/items`).then(function (response) {
                    vm.countWishList = response.data['data'][0]['models'];
                    iconCounts.forEach(count => {
                        count.textContent = vm.countWishList.length
                    })
                    e.target.src = '/images/icon-lable-full.svg';
                    localStorage.setItem('itemCount', vm.countWishList.length)
                });
            }
            let flagIsInWish = false;
            vm.countWishList.forEach((wishProduct) => {
                if (product.id === wishProduct.id) {
                    flagIsInWish = true;
                }
            });

            //if new wish -> add to db
            if (!flagIsInWish) {
                let data = {
                    user_id: userId,
                    model_id: product.id
                }

                axios.post(`/wishlist/store/${product.id}`, data).then(function (response) {
                    vm.countWishList.push(product)

                    iconCounts.forEach(count => {
                        count.textContent = vm.countWishList.length
                    })
                    e.target.src = '/images/icon-lable-full.svg';
                    localStorage.setItem('itemCount', vm.countWishList.length)

                    if (localStorage.getItem('lang') === 'ar-sa') {
                        window.notify('أضيف لقائمة الأماني', 'success')

                    } else {
                        window.notify('Added to wishlist', 'success')
                    }
                }).catch(function (error) {
                    if (localStorage.getItem('lang') === 'ar-sa') {
                        window.notify('لم تتم إضافته إلى قائمة الرغبات', 'error')
                    } else {
                        window.notify('Not added to wishlist', 'error')
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss">
@import "../../sass/front/card-model";

.product-image {
    cursor: pointer;
}
</style>
